const MARGIN = 8;
const GAP = 24;

// Fixed coordinates are measured against the visible viewport, including an
// on-screen keyboard or pinch zoom. Small screens can place the panel below its
// anchor; when neither side fits, keeping the controls reachable takes priority.
export function toolbarPopoverPosition(anchor, panel, viewport) {
  const left = (viewport.left || 0) + MARGIN;
  const top = (viewport.top || 0) + MARGIN;
  const right = (viewport.left || 0) + viewport.width - MARGIN;
  const bottom = (viewport.top || 0) + viewport.height - MARGIN;
  const maxWidth = Math.max(0, right - left);
  const maxHeight = Math.max(0, bottom - top);
  const width = Math.min(panel.width, maxWidth);
  const height = Math.min(panel.height, maxHeight);
  let x = anchor.right + GAP;
  let y = anchor.top;

  if (x + width > right) {
    if (anchor.left - GAP - width >= left) {
      x = anchor.left - GAP - width;
    } else {
      x = anchor.left;
      if (anchor.bottom + GAP + height <= bottom) y = anchor.bottom + GAP;
      else if (anchor.top - GAP - height >= top) y = anchor.top - GAP - height;
    }
  }

  return {
    left: Math.max(left, Math.min(x, right - width)),
    top: Math.max(top, Math.min(y, bottom - height)),
    maxWidth,
    maxHeight
  };
}
